console.log('Ready javascript');
//document.addEventListener("touchstart", function(){}, true);

$('.js-c-gal-swiper').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0, 
  speed: 10000,
  cssEase: 'linear',
  nextArrow: false,
  prevArrow: false,
  responsive: [
  {
    breakpoint: 769, 
    settings: {
      slidesToShow: 3, 
    }
  },
  ]
});
$(window).resize(function() {
  if ($('.js-c-gal-swiper').length) { // Verifica si el elemento existe
    $('.js-c-gal-swiper').slick('setPosition');
  }
});


$('.js-gal-text-swiper').slick({
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0, 
  speed: 10000,
  cssEase: 'linear',
  nextArrow: false,
  prevArrow: false,
  responsive: [
  {
    breakpoint: 1700, 
    settings: {
      slidesToShow: 5, 
    }
  },
  {
    breakpoint: 1400, 
    settings: {
      slidesToShow: 5, 
    }
  },
  {
    breakpoint: 1200, 
    settings: {
      slidesToShow: 4, 
    }
  },
  {
    breakpoint: 1024, 
    settings: {
      slidesToShow: 3, 
    }
  },
  {
    breakpoint: 768, 
    settings: {
      slidesToShow: 2, 
    }
  },
  {
    breakpoint: 500, 
    settings: {
      slidesToShow: 1, 
    }
  },
  ]
});
$(window).resize(function() {
  if ($('.js-gal-text-swiper').length) { // Verifica si el elemento existe
    $('.js-gal-text-swiper').slick('setPosition');
  }
});



$('.js-eventClick__this__e-plus-info__content span').click(function(event){
  whichLink=$('.js-eventClick__this__e-plus-info__content span').index(this);
  $('.js-eventClick__this__e-plus-info__content').eq(whichLink).toggleClass('is-active');
  event.preventDefault();
});


$('.c-carousel-testimonials__container').slick({
  dots: false,
  infinite: true,
  speed: 300,
  autoplaySpeed: 30000,
  slidesToShow: 4,
  autoplay: true,
  variableWidth: true,
  centerMode: true
});

if (document.getElementsByClassName('c-carousel-testimonials__comments')[0]) {
  var carousel__comments = $('.c-carousel-testimonials__comments');
  carousel__comments[0].classList.remove('dn');
  $('.c-carousel-testimonials__container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // console.log(nextSlide);
    carousel__comments.addClass('dn e-animation-text-focus-in-100');
    carousel__comments[nextSlide].classList.remove('dn');
  });
}



$("#js-eventHover__c-access__item-btn-1 , .js-eventHover__c-access__item-btn-1")
.hover (
        function() {
          $('.c-access' ).addClass('is-active-1');
        }, 
        function() {
          $('.c-access' ).removeClass('is-active-1');
        });

$('#js-eventHover__c-access__item-btn-2 , .js-eventHover__c-access__item-btn-2')
.hover (
        function() {
        });



$( window).scroll(function() {
  if ($(window).scrollTop()> 300 ) {
    $('#header').addClass('is-active');
  } else  {
    $('#header').removeClass('is-active');
  }
});




$(document).keyup(function(e) {
  if ($('#html').hasClass('is-active-menu')) {
    if (e.keyCode === 27) { $('#js-eventClick-toggle--header__btn-menu').click();}
  }
});

$('#js-body__header__menu-mobile , #js-eventClick-clossed--header__btn-menu').click(function(){
  $('#js-eventClick-toggle--header__btn-menu').click();
});


$('#js-eventClick-toggle--header__btn-menu').click(function(e){
  e.preventDefault();
  this.classList.toggle('is-active');
  if (this.classList.contains('is-active')==true){
    $('html').addClass('is-active-menu');
    $('html').removeClass('is-clossed-active-menu');
  } else {
    $('html').addClass('is-clossed-active-menu');
    $('html').removeClass('is-active-menu');
  }
});





$("a").on('click', function(event) {
  if (this.hash !== "") {
    var hash = this.hash;
    var headerHeight = document.getElementsByTagName("header");
    if (headerHeight[0].classList != "fixed"){
      var topPage = $(hash).offset().top;
    } else {
      var topPage = $(hash).offset().top;
    }
    $('html, body').animate({
      scrollTop: topPage
    }, 1000, function(){
     window.location.hash = hash;
     var archos = window.location.hash.substr(1);
   });
  } 
});

var count_items = $('.c-carousel .item').length;

// console.log(count_items);
// if (count_items>4) {
  var $carousel = $('.js-carousel-flickity').flickity({
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    groupCells:1,
    autoPlay: 2800,
    imagesLoaded: false,
    percentPosition: true,

    on: {
      ready: function() {
      },
      change: function( index ) {
        this.player.play();
      },
      dragMove: function( event, pointer, moveVector ){
        var $link = $('.js-carousel-flickity').find('a').addClass('e-pointer-events--none');
      },
      dragEnd: function( event, pointer ){
        var $link = $('.js-carousel-flickity').find('a').removeClass('e-pointer-events--none');
      },
      staticClick: function(event, pointer, cellElement, cellIndex){
        if (!cellElement) {
          return;
        }
        var $zoomurl = $(cellElement).find('img').attr('src');
        $(cellElement).find('a').removeClass('e-pointer-events--none');
      }
    }
  });
// }

var count_items = $('.js-carousel-flickity--news .item').length;
if (count_items>3) {
  var $carousel = $('.js-carousel-flickity--news').flickity({
    cellAlign: 'left',
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true,
    groupCells:1,
    autoPlay: 4000,
    imagesLoaded: true,
    percentPosition: true,
    on: {
      ready: function() {
      },
      change: function( index ) {
        this.player.play();
      },
      dragMove: function( event, pointer, moveVector ){
        var $link = $('.js-carousel-flickity').find('a').addClass('e-pointer-events--none');
      },
      dragEnd: function( event, pointer ){
        var $link = $('.js-carousel-flickity').find('a').removeClass('e-pointer-events--none');
      },
      staticClick: function(event, pointer, cellElement, cellIndex){
        if (!cellElement) {
          return;
        }
        var $zoomurl = $(cellElement).find('img').attr('src');
        $(cellElement).find('a').removeClass('e-pointer-events--none');
      }
    }
  });
}




// var count_items = $('.js-carousel-flickity--personal .item').length;
// if (count_items>4) {
//   var $carousel = $('.js-carousel-flickity--personal').flickity({
//     cellAlign: 'left',
//     contain: true,
//     prevNextButtons: false,
//     pageDots: true,
//     wrapAround: true,
//     groupCells:1,
//     autoPlay: 30000,
//     imagesLoaded: true,
//     percentPosition: true,
//     //adaptiveHeight: true,
//     on: {
//       ready: function() {
//       },
//       change: function( index ) {
//         this.player.play();
//       },
//       dragMove: function( event, pointer, moveVector ){
//         var $link = $('.js-carousel-flickity--personal').find('a').addClass('e-pointer-events--none');
//       },
//       dragEnd: function( event, pointer ){
//         var $link = $('.js-carousel-flickity--personal').find('a').removeClass('e-pointer-events--none');
//       },
//       staticClick: function(event, pointer, cellElement, cellIndex){
//         if (!cellElement) {
//           return;
//         }
//         var $zoomurl = $(cellElement).find('img').attr('src');
//         $(cellElement).find('a').removeClass('e-pointer-events--none');
//       }
//     }
//   });
// }


// var count_items = $('.js-carousel-flickity--products .item').length;
// if (count_items) {
//   var $carousel = $('.js-carousel-flickity--products').flickity({
//     cellAlign: 'left',
//     contain: true,
//     prevNextButtons: true,
//     pageDots: true,
//     wrapAround: false,
//     groupCells:1,
//     autoPlay: 30000,
//     imagesLoaded: true,
//     percentPosition: true,
//     adaptiveHeight: true,
//     on: {
//       ready: function() {
//       },
//       change: function( index ) {
//         this.player.play();
//       },
//       dragMove: function( event, pointer, moveVector ){
//         var $link = $('.js-carousel-flickity--products').find('a').addClass('e-pointer-events--none');
//       },
//       dragEnd: function( event, pointer ){
//         var $link = $('.js-carousel-flickity--products').find('a').removeClass('e-pointer-events--none');
//       },
//       staticClick: function(event, pointer, cellElement, cellIndex){
//         if (!cellElement) {
//           return;
//         }
//         var $zoomurl = $(cellElement).find('img').attr('src');
//         $(cellElement).find('a').removeClass('e-pointer-events--none');
//       }
//     }
//   });
// }



